import { BaseInput } from "shared/components/forms/BaseInput";
import { type CredentialFormProps } from "./types";

export const QuextCredentialForm = ({ register }: CredentialFormProps) => (
  <BaseInput
    id="quext_customer_id"
    label="Customer ID"
    {...register("quext_customer_id")}
    required
  />
);
